module.exports = __webpack_public_path__ + "img/img33.f25b1f56.svg";